import React from "react";
import {SettingsLayout} from "../layouts/dashboard/SettingsLayout";

export function withSettingsLayout<P extends object>(
    Component: React.ComponentType<P>
): React.FC<P> {
    const Wrapped: React.FC<P> = (props) => (
        <SettingsLayout>
            <Component {...props} />
        </SettingsLayout>
    );

    Wrapped.displayName = `WithSettingsLayout(${Component.displayName || Component.name || "Component"})`;

    return Wrapped;
}
